import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { coursesData, categories } from '../../pages/courses/coursesData';

const CoursesSection = () => {
    const [activeCategory, setActiveCategory] = useState("IT Courses");
    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    // Set active tab from navigation state if available
    useEffect(() => {
        if (location.state && location.state.category) {
            setActiveCategory(location.state.category || "IT Courses");

            // Scroll to the section after a robust delay to ensure full rendering
            setTimeout(() => {
                const section = document.getElementById('courses1') || document.getElementById('courses');
                if (section) {
                    const yOffset = -100; // Adjust for any sticky header
                    const y = section.getBoundingClientRect().top + window.pageYOffset + yOffset;
                    window.scrollTo({ top: y, behavior: 'smooth' });
                }
            }, 300);
        }
    }, [location.state]);


    const visibleCourses = coursesData;
    const filteredCourses = visibleCourses.filter(course => course.category === activeCategory);

    return (
        <section className="gk-courses-section" id="courses">
            <div className="gk-container">
                <div className="gk-section-header">
                    <span className="gk-subtitle">Upgrade Your Skills</span>
                    <h2 className="gk-title">Explore Our Top Courses</h2>
                    <div className="gk-underline"></div>
                </div>

                {/* Offer Banner */}
                {/* <div className="gk-offer-banner">
                    <div className="gk-banner-header">
                        <span className="gk-live-badge">🔴 Live Offer</span>
                        <h3>Batch Filling Fast !</h3>
                        <p className="gk-banner-explanation">Course fee discounts decrease as the batch fills. Enroll early to get the highest benefit.</p>
                    </div>

                    <div className="gk-slabs-container">
                        <div className="gk-slab-track">
                            {[
                                { id: 1, label: 'Early Bird', discount: '20% OFF' },
                                { id: 2, label: 'Value Saver', discount: '10% OFF' },
                                { id: 3, label: 'Standard', discount: '0% OFF' },
                            ].map((slab, index) => (
                                <React.Fragment key={slab.id}>
                                    <div className={`gk-slab-wrapper ${index <= activeSlab ? 'active' : ''}`}>
                                        <div className="gk-slab-circle">{slab.id}</div>
                                        <div className="gk-slab-content" id="courses1">
                                            <span className="gk-slab-title">{slab.label}</span>
                                            <span className="gk-slab-discount">{slab.discount}</span>
                                        </div>
                                    </div>
                                    {index < 2 && (
                                        <div className={`gk-slab-line ${index < activeSlab ? 'active' : ''}`}></div>
                                    )}
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                </div> */}

                {/* Category Tabs */}
                <div className="gk-tabs-container" style={{ marginBottom: '2rem', marginTop: '1rem' }}>
                        {categories.map((cat) => {
                            const count = visibleCourses.filter(course => course.category === cat).length;
                            if (count === 0) return null;

                            const isActive = activeCategory === cat;
                            return (
                                <button
                                    key={cat}
                                    className={`gk-tab-btn ${isActive ? 'active' : ''}`}
                                    onClick={() => setActiveCategory(cat)}
                                    style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', fontWeight: 'bold' }}
                                >
                                    {cat}
                                    <span style={{
                                        backgroundColor: isActive ? '#ea580c' : '#f1f5f9',
                                        color: isActive ? '#ffffff' : '#64748b',
                                        borderRadius: '50%',
                                        width: '18px',
                                        height: '18px',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '11px',
                                        fontWeight: 'bold',
                                        lineHeight: '0',
                                        border: isActive ? 'none' : '1px solid #e2e8f0'
                                    }}>
                                        {count}
                                    </span>
                                </button>
                            );
                        })}
                    </div>

                <div className={`gk-courses-grid ${filteredCourses.length <= 3 ? 'centered-grid-3' : ''}`}>
                    {filteredCourses.map((course) => {
                        const courseUrl = course.seoPath ? `/${course.seoPath}` : `/course/${course.slug || course.id}`;
                        return (
                            <div className="gk-course-card" key={course.id}>
                                <Link to={courseUrl} className="gk-card-banner-new">
                                    <img src={course.image} alt={`${course.title} course training at Skill Ascent`} loading="lazy" />
                                </Link>

                                <div className="gk-card-content-new">
                                    <h3 className="gk-course-title-new">
                                        <Link to={courseUrl} style={{ color: 'inherit', textDecoration: 'none' }}>
                                            {course.title}
                                        </Link>
                                    </h3>

                                    <div className="gk-course-meta-new">
                                        <div className="gk-meta-col-new">
                                            <span className="gk-meta-label-new">Duration:</span>
                                            <span className="gk-meta-value-new">{course.duration}</span>
                                        </div>
                                        <div className="gk-meta-col-new">
                                            <span className="gk-meta-label-new">Best For:</span>
                                            <span className="gk-meta-value-new">{course.role}</span>
                                        </div>
                                    </div>

                                    <div className="gk-course-action-new">
                                        <button
                                            className="gk-view-program-btn-new"
                                            style={{ fontFamily: 'inherit' }}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                let ref = searchParams.get("ref");
                                                if (!ref) {
                                                    const windowParams = new URLSearchParams(window.location.search);
                                                    ref = windowParams.get("ref");
                                                }

                                                if (ref) {
                                                    axios.post(`https://api.skillascent.in/api/BulkSms/hotleadsave?ref=${encodeURIComponent(ref)}&course=${encodeURIComponent(course.title)}`, {})
                                                        .then(() => console.log(`Hot lead captured for ${course.title}`))
                                                        .catch(err => console.error("Hot lead tracking failed", err))
                                                        .finally(() => {
                                                            navigate(courseUrl);
                                                        });
                                                } else {
                                                    navigate(courseUrl);
                                                }
                                            }}
                                        >
                                            Explore Course
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginLeft: "4px" }}><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

            </div>
        </section>
    );
};

export default CoursesSection;